import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_RELIGION,
  DELETE_RELIGION,
  UPDATE_RELIGION,
  ADD_NEW_RELIGION,
} from "./actionType";

import {
  getReligionSuccess,
  getReligionFail,
  deleteReligionSuccess,
  deleteReligionFail,
  updateReligionSuccess,
  updateReligionFail,
  addReligionSuccess,
  addReligionFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getReligionApi,
  updateReligionApi,
  deleteReligionApi,
  addNewReligionApi
} from "../../helpers/backend_helper";

function* getReligion({ payload: religion }) {
  try {
    const response = yield call(getReligionApi, religion);
    yield put(getReligionSuccess(GET_RELIGION, response.data));
  } catch (error) {
    yield put(getReligionFail(GET_RELIGION, error));
  }
}

function* onUpdateReligion({ payload: religion }) {
  try {
    const response = yield call(updateReligionApi, religion);
    yield put(updateReligionSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateReligionFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteReligion({ payload: religion }) {
  try {
    const response = yield call(deleteReligionApi, religion);
    yield put(deleteReligionSuccess({ religion, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteReligionFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewReligion({ payload: religion }) {
  try {
    const response = yield call(addNewReligionApi, religion);
    yield put(addReligionSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addReligionFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetReligion() {
  yield takeEvery(GET_RELIGION, getReligion);
}

export function* watchUpdateReligion() {
  yield takeEvery(UPDATE_RELIGION, onUpdateReligion);
}

export function* watchDeleteReligion() {
  yield takeEvery(DELETE_RELIGION, onDeleteReligion);
}

export function* watchAddNewReligion() {
  yield takeEvery(ADD_NEW_RELIGION, onAddNewReligion);
}

function* religionSaga() {
  yield all([
    fork(watchGetReligion),
    fork(watchDeleteReligion),
    fork(watchUpdateReligion),
    fork(watchAddNewReligion)
  ]);
}

export default religionSaga;
